const investmentElecBasic = {
  state: {
    pageType: 'list',
    beginUpdate: new Date(),
    meter: null
  },
  mutations: {
    set_investment_elec_basic_pageType (state, data) {
      state.pageType = data
    },
    set_investment_elec_basic_update (state, data) {
      state.beginUpdate = data
    },
    set_investment_elec_basic_meter (state, data) {
      state.meter = data
    }
  },
  getters: {

  },
  actions: {

  }
}
export default investmentElecBasic
